import BaseSearchSelect from 'components/atoms/base-search-select';
import { useGetCareManagers } from 'infrastructure/hooks/agency-doctor';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { fullNamePresenter } from 'utils';

import { useFilter } from './filter/use-filter';
import s from './styles.module.scss';

const TransferFrom: FC = () => {
  const { t } = useTranslation();
  const { filter, updateFilter, debouncedUpdateFilter } = useFilter();
  const managers = useGetCareManagers({
    fullName: filter.fromName,
  });

  return (
    <div className={s['form-group']}>
      <label>{t('labels.transferFrom')}</label>
      <BaseSearchSelect
        isLoading={managers.isLoading}
        options={managers.data?.rows?.map((m) => ({
          label: fullNamePresenter({
            firstName: m.firstName,
            lastName: m.lastName,
          }),
          value: m.guid,
        }))}
        placeholder={t('labels.select')}
        value={filter.fromAgencyDoctorGuid}
        onChange={(searchValue) =>
          debouncedUpdateFilter({ fromName: searchValue })
        }
        onSelect={(v) => {
          updateFilter({ fromAgencyDoctorGuid: v, fromName: undefined });
        }}
        onClear={() => {
          updateFilter({
            fromName: undefined,
            fromAgencyDoctorGuid: undefined,
          });
        }}
      />
    </div>
  );
};

export default TransferFrom;
